export const getChecklistSelectionChanges = (
  applied: string[],
  draft: string[]
): string[] => {
  const appliedSet = new Set(applied);
  const draftSet = new Set(draft);
  const changes: string[] = [];

  draftSet.forEach((value: string): void => {
    if (!appliedSet.has(value)) {
      changes.push(value);
    }
  });

  appliedSet.forEach((value: string): void => {
    if (!draftSet.has(value)) {
      changes.push(value);
    }
  });

  return changes;
};
